import styled from 'styled-components';

// COLORS
import { theme } from '../../constants/theme';

// ENUMS
import { Themes } from '../../enums/themes';

// INTERFACES
import { IModal } from '../../interfaces/Modal.interface';

export const Overlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background: rgba(10, 10, 10, 0.5);
`;

export const Container = styled.div<IModal>`
  width: 480px;
  max-width: 100%;
  border-radius: 8px;
  padding-top: 24px;
  overflow: hidden;
  background-color: ${theme.colors.primary.black};

  ${({ themeProp }) =>
    (themeProp === Themes.DEFAULT || themeProp === Themes.LIGHT) &&
    `
    background: ${theme.colors.primary.white};
    border: 1px solid ${theme.colors.primary.lightGray};
  `}
`;

export const Title = styled.div<IModal>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  margin: 0 48px 33px 48px;
  font-size: 17px;
  line-height: 24px;
  letter-spacing: 0.01em;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};

  > svg {
    margin-bottom: 40px;
  }

  ${({ centered }) =>
    centered &&
    `
    justify-content: center;
    text-align: center;
  `}

  color: ${theme.colors.primary.white};

  ${({ themeProp }) =>
    (themeProp === Themes.DEFAULT || themeProp === Themes.LIGHT) &&
    `
    color: ${theme.colors.primary.black};
  `}

  ${({ alert }) =>
    alert &&
    `
    color: ${theme.colors.secondary.red100};
  `}
`;

export const TitleContent = styled.span`
  display: block;
  width: 100%;
`;

export const Subtitle = styled.h2<IModal>`
  margin: 0 0 48px 0;
  padding: 0 48px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};

  ${({ centered }) =>
    centered &&
    `
    text-align: center;
  `}

  ${({ themeProp }) =>
    (themeProp === Themes.DEFAULT || themeProp === Themes.LIGHT) &&
    `
    color: ${theme.colors.secondary.gray200};
  `}

  ${({ themeProp }) =>
    themeProp !== Themes.DEFAULT &&
    themeProp !== Themes.LIGHT &&
    `
    color: ${theme.colors.primary.white};
    opacity: 0.7;
  `}
`;

export const Content = styled.div<IModal>`
  padding: 21px 48px 48px 48px;
  ${({ centered }) =>
    centered &&
    `
    text-align: center;
  `}

  p {
    font-size: 16px;
    line-height: 32px;
    font-weight: normal;
    font-family: 'Clan Pro';
    font-weight: ${theme.weights.regular};

    ${({ themeProp }) =>
      (themeProp === Themes.DEFAULT || themeProp === Themes.LIGHT) &&
      `
      color: ${theme.colors.secondary.gray200};
    `}

    ${({ themeProp }) =>
      themeProp !== Themes.DEFAULT &&
      themeProp !== Themes.LIGHT &&
      `
      color: ${theme.colors.primary.white};
    `}
  }
`;

export const Actions = styled.div<IModal>`
  padding: 24px 48px;
  display: flex;
  align-items: center;
  box-sizing: border-box;

  ${({ themeProp }) =>
    (themeProp === Themes.DEFAULT || themeProp === Themes.LIGHT) &&
    `
    background: ${theme.colors.primary.lightGray};
  `}

  button {
    width: 100%;
    text-align: left;
  }

  ${({ twoActions }) =>
    twoActions &&
    `
    button {
      min-width: 50%;
    }
  `}

  ${({ themeProp }) =>
    themeProp !== Themes.DEFAULT &&
    themeProp !== Themes.LIGHT &&
    `
    background: ${theme.colors.primary.transparentBgOpacity};
  `}
`;

export const Close = styled.div<IModal>`
  position: absolute;
  right: -40px;
  top: -8px;
  ${({ withIcon }) =>
    withIcon == true &&
    `
    top: 18px;
  `}
  ${({ themeProp }) =>
    themeProp === Themes.DARK &&
    `
    svg path {
      fill: ${theme.colors.primary.white};
    }
  `}
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
`;
